<div *ngIf="isLoading" class="loading">
    <mat-progress-spinner
      color="primary"
      mode="indeterminate"
    ></mat-progress-spinner>
</div>
  
<con-page-layout *ngIf="dataSource.data.length > 0">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'trainer_dashboard' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'availability_title' | translate }}</div>
  <div fxLayout="row" fxLayoutAlign="end start">
    <button mat-raised-button *ngIf="isContributor"
    color="primary" 
    (click)="exportDataToExcel()">{{ 'export_data' | translate }}</button>
  </div>
  <br />
  
  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <div class="matTable-container mat-elevation-z8" *ngIf="media.isActive('lg') || media.isActive('xl') || media.isActive('md')">
      <mat-table matSort #table [dataSource]="dataSource" class="mat-elevation-z8">

        <!-- Class Name Column -->
        <ng-container cdkColumnDef="class_name">
          <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'class_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="15%" *cdkCellDef="let available"> {{available.class_name}} </mat-cell>
        </ng-container>

        <!-- Account Name Column -->
        <ng-container cdkColumnDef="account_name">
          <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'account_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="15%" *cdkCellDef="let available"> {{available.account_name}} </mat-cell>
        </ng-container>

        <!-- First Name Column -->
        <ng-container cdkColumnDef="first_name">
          <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'first_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="10%" *cdkCellDef="let available"> {{available.first_name}} </mat-cell>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container cdkColumnDef="last_name">
          <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'last_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="10%" *cdkCellDef="let available"> {{available.last_name}} </mat-cell>
        </ng-container>

        <!-- Email-Id Column -->
        <ng-container cdkColumnDef="email_id">
          <mat-header-cell fxFlex="20%" *cdkHeaderCellDef mat-sort-header>{{ 'student_email' | translate }}</mat-header-cell>
          <mat-cell fxFlex="20%" *cdkCellDef="let available"> {{available.email_id}} </mat-cell>
        </ng-container>

        <!-- Folder Name Column -->
        <ng-container cdkColumnDef="folder_name">
          <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'folder_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="15%" *cdkCellDef="let available"> {{available.folder_name}} </mat-cell>
        </ng-container>

        <!-- Group Name Column -->
        <ng-container cdkColumnDef="group_name">
          <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'group_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="15%" *cdkCellDef="let available"> {{available.group_name}} </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>

    <br />

    <!-- Mobile view -->
    <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))" class="mobile-list">
      <ng-container *ngFor="let available of dataSource.data">

        <mat-list-item class="mobile-item">

          <div class="mobile-card">

            <!-- Header -->
            <div class="mobile-header">
              {{ available.account_name }}
            </div>

            <!-- Body -->
            <div class="mobile-body">

              <div class="info-row">
                <span class="label">{{ 'class_name' | translate }}</span>
                <span class="value">{{ available.class_name }}</span>
              </div>

              <div class="info-row">
                <span class="label">{{ 'student_name' | translate }}</span>
                <span class="value">
                  {{ available.first_name }} {{ available.last_name }}
                </span>
              </div>

              <div class="info-row">
                <span class="label">{{ 'student_email' | translate }}</span>
                <span class="value breakword">{{ available.email_id }}</span>
              </div>

              <div class="info-row">
                <span class="label">{{ 'folder_name' | translate }}</span>
                <span class="value">{{ available.folder_name }}</span>
              </div>

              <div class="info-row">
                <span class="label">{{ 'group_name' | translate }}</span>
                <span class="value">{{ available.group_name }}</span>
              </div>

            </div>
          </div>
        </mat-list-item>
      </ng-container>
    </mat-list>

  </con-page-layout-content>
</con-page-layout>
